import { localeProperties } from '@/library/locale/i18n'
export default {
  computed: {
    userLocale () {
      return localeProperties.getUserLocale
    },
    i18nLocale () {
      console.log('locale this.$i18n.locale', this.$i18n.locale)
      return '/' + this.$i18n.locale
    }
  },

  methods: {
    mediaServer (path) {
      var mediaHostName = window.ctsautoconf.MEDIA_CONTENT_HOSTNAME

      if (mediaHostName) {
        var absolutePath = (mediaHostName.indexOf('http://') > -1 || mediaHostName.indexOf('https://') > -1) ? mediaHostName : '//' + mediaHostName
      }

      if (path) {
        var result = ''
        if (path.indexOf('http://') > -1 || path.indexOf('https://') > -1) {
          result = path
          return result
        }
        if (mediaHostName) {
          result = absolutePath + path
          return result
        }
      } else {
        if (mediaHostName) {
          return absolutePath
        } else {
          return ''
        }
      }
      return path
    },
    mediaServerHostname () {
      let mediaHostName = window.ctsautoconf.MEDIA_CONTENT_HOSTNAME
      if (mediaHostName) {
        let path = (mediaHostName.indexOf('http://') > -1 || mediaHostName.indexOf('https://') > -1) ? mediaHostName : '//' + mediaHostName
        return path
      }
      return ''
    },
    i18nToRouterLink (route) {
      let currentLang = this.i18nLocale.toLowerCase() === '/uk' ? '/en' : this.i18nLocale.toLowerCase()
      if (route === '/') return currentLang
      if (route.indexOf('/') === 0) {
        return currentLang + route
      }
      return currentLang + '/' + route
    }
  },

  created () {

  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/Url.js